import { connect } from 'react-redux'
import { compose, withHandlers, withState } from 'recompose'
import { withTranslation } from 'react-i18next'
import { userIdSelector } from '../../../store/selectors/baseSelectors'
import { deleteComment, editComment } from '../../../store/actions/discuss'
import { withShortcuts } from '../../../containers/Shortcuts';

const CommentContianer = compose(
  connect(
    state => ({
      userId: userIdSelector(state)
    }),
    {
      deleteComment,
      editComment
    }
  ),
  withState('editedText', 'setEditedText', null),
  withHandlers({
    remove: ({ deleteComment, comment, thread }) => () =>
      deleteComment(comment, thread),
    edit: ({ setEditedText, comment }) => () => setEditedText(comment.text),
    saveEdit: ({
      comment,
      thread,
      editedText,
      editComment,
      setEditedText,
      deleteComment
    }) => () => {
      if (!editedText) deleteComment(comment, thread)
      else
        editComment(comment, thread, editedText).then(() => setEditedText(null))
    },
    cancelEdit: ({ setEditedText }) => () => setEditedText(null)
  }),
  withShortcuts('DISCUSS', props => (action, event) => {
    switch (action) {
      case 'POST_COMMENT':
        props.saveEdit()
        event.preventDefault()
        break
      case 'CANCEL_COMMENT':
        props.cancelEdit()
        event.stopPropagation()
        event.preventDefault()
        break
      default:
    }
  }),
  withTranslation()
)

export default CommentContianer
